export default function(params) {
  var self = this;
  var media_route = '';

  if (params.media_s3_data && params.media_s3_data.download) {
    var data = params.media_s3_data;
    media_route = `https://docs.google.com/viewer?url=${encodeURIComponent(data.download)}&embedded=true`;
  } else {
    media_route = Kadenze.Routes.document_conversion_job_path(params.id)
  }

  self.defaults = {
    route: media_route,
    style: {}
  };

  self.config = _.extend({}, self.defaults, params);
  self.emitter = new Emitter();
  self.presented = false;

  self.present = function() {
    if(self.raiseWarnings() || self.presented) return;
    self.appendViewer();
    self.presented = true;
    self.emitter.emit('presented');
  };

  self.appendViewer = function() {
    self.$viewer = $('<iframe/>', { class: 'document-preview', src: self.config.route, allowfullscreen: true, frameborder: 0 });

    if (_.isFunction(self.config.onLoad))
      self.$viewer.on('load', self.config.onLoad);

    self.$viewer.css(self.config.style);
    self.config.$container.append(self.$viewer);
  };

  self.destroy = function() {
    self.$viewer.remove();
    self.emitter.emit('destroy');
  };

  self.hide = function() {
    self.$viewer.hide();
    self.emitter.emit('hide');
  };

  self.show = function() {
    self.$viewer.show();
    self.emitter.emit('show');
  };

  self.raiseWarnings = function() {
    if (!self.config.id && !self.config.media_s3_data.download) {
      console.warn('Iframe Document Renderer: Must provide document id; { id: 1 }');
      return true;
    } else if(!self.config.$container) {
      console.warn('Iframe Document Renderer: Must provide parent container as a jQuery object; { $container: $(".my-container") }');
      return true;
    } else {
      return false;
    }
  };

  return self;
}
